import { useEffect, useState } from "react";

/**
 * Botón flotante "volver arriba". Aparece al bajar más de `threshold` px y
 * hace scroll suave al tope. El scroll es de la ventana (el Layout usa
 * min-h-screen sin contenedor con overflow propio), por eso escuchamos
 * `window` y usamos `window.scrollTo`. Pensado para vistas largas como el
 * detalle de una guía.
 */
export default function ScrollToTopButton({
  threshold = 400,
}: {
  threshold?: number;
}) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > threshold);
    onScroll(); // estado inicial por si la página ya viene scrolleada
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);

  if (!visible) return null;

  return (
    <button
      type="button"
      aria-label="Volver arriba"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 right-6 z-40 grid h-11 w-11 place-items-center
                 rounded-full border border-ink-700 bg-ink-800/90 text-accent-300
                 shadow-lg backdrop-blur transition hover:bg-ink-700 hover:text-accent-200
                 focus:outline-none focus:ring-2 focus:ring-accent-500/40"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M12 19V5" />
        <path d="m5 12 7-7 7 7" />
      </svg>
    </button>
  );
}
